import { detectDeviceEnvironmentConstants, ingenuity } from "@quest/base-core";
import { RetriggerView, SlotConstantsBehavior } from "@quest/murka-games-behavior-panther";



export class FreeGameRetriggerView extends RetriggerView {


    /**
     * Method overrided to make view scaling simimal to free game view for trail alingment.
     */
    protected setViewProperties(): void {
        if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
            this.pivot.set(ingenuity.configData.width * SlotConstantsBehavior.HALF_CONVERTER, ingenuity.configData.height * SlotConstantsBehavior.HALF_CONVERTER);
            let scale = Math.max(innerHeight /ingenuity.configData.width, innerWidth /ingenuity.configData.height);
            this.scale.set(scale);
            this.x = (innerWidth * SlotConstantsBehavior.HALF_CONVERTER);
            this.y = (innerHeight * SlotConstantsBehavior.HALF_CONVERTER) + SlotConstantsBehavior.ADD_IN_Y;
        }
        else {
            this.pivot.set(ingenuity.configData.width * SlotConstantsBehavior.HALF_CONVERTER, ingenuity.configData.height * SlotConstantsBehavior.HALF_CONVERTER);
            this.scale.set(ingenuity.deviceEnv.getLandcapeMaxReelScale());
            this.x = (innerWidth * SlotConstantsBehavior.HALF_CONVERTER) + (SlotConstantsBehavior.REEL_SIDE_SPACE * this.scale.x);
            if (ingenuity.deviceEnv.isDesktop) {
                this.y = (innerHeight * SlotConstantsBehavior.HALF_CONVERTER) + ((SlotConstantsBehavior.REEL_BOTTOM_SPACE / 2) * this.scale.x);
            }
            else {
                this.y = (innerHeight * SlotConstantsBehavior.HALF_CONVERTER) + ((SlotConstantsBehavior.REEL_BOTTOM_SPACE_LANDSCAPE / 2) * this.scale.x);
            }
        }
    }




}